import { useEffect } from 'react';

export const useExpiredEvents = (): void => {
    useEffect(() => {
        const exitExpiredEventsEl = document.querySelector(
            '.js-exit-expired-events',
        );
        const hiddenCssClass = 'is-hidden';
        const expiredListingPageEl = document.querySelector(
            '.js-expired-related-events',
        );
        const defaultListingPageEL = document.querySelector(
            '.js-hidden-when-expired',
        );

        exitExpiredEventsEl?.addEventListener('click', (event) => {
            event.preventDefault();
            expiredListingPageEl?.classList.add(hiddenCssClass);
            defaultListingPageEL?.classList.remove(hiddenCssClass);
            document;
        });
    }, []);
};
